'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.order.service
 * @description
 * # order.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('orderService', function(BaseService, errorService) {

    var service = new BaseService();
    service.getAll = getAll;
    service.getById = getById;
    service.create = create;
    service.createMaintenance = createMaintenance;
    service.updateMaintenance = updateMaintenance;
    service.update = update;
    service.delete = deleteOrder;

    return service;

    function getAll() {
      return service.http.get(service.baseUrl + '/orders')
        .then(handleSuccess)
        .catch(handleError);
    }

    function getById(id) {
      return service.http.get(service.baseUrl + '/orders/' + id)
        .then(handleSuccess)
        .catch(handleError);
    }

    function create(order) {
      return service.http.post(service.baseUrl + '/orders', order)
        .then(handleSuccess)
        .catch(handleError);
    }

    function createMaintenance(order) {
      return service.http.post(service.baseUrl + '/orders/maintenance', order)
        .then(handleSuccess)
        .catch(handleError);
    }

    function updateMaintenance(order) {
      return service.http.put(service.baseUrl + '/orders/maintenance/' + order.id, order)
        .then(handleSuccess)
        .catch(handleError);
    }

    function update(order) {
      return service.http.put(service.baseUrl + '/orders/' + order.id, order)
      .then(handleSuccess)
      .catch(handleError);
    }

    function deleteOrder(id) {
      return service.http.delete(service.baseUrl + '/orders/' + id)
      .then(handleSuccess)
      .catch(handleError);
    }

    function handleSuccess(response) {
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
